module.exports = __webpack_public_path__ + "img/back.6d4889d9.svg";